/* istanbul ignore file */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactHeader from './ContactHeader/ContactHeader';
import ContactInfo from './ContactInfo/ContactInfo';
import HeroBgImage from './contact-hero-background.jpg';
import './Contact.css';

const Contact = () => (
    <div className="contact-view">
        <Helmet>
            <title>Contact Us at HPP | Hudson Pacific Properties</title>
            <meta name="description" property="og:description" content="Call, email or stop by any of  Hudson Pacific's locations in Los Angeles, Silicon Valley, San Francisco or Seattle." />
        </Helmet>
        <ContactHeader
            backgroundImage={HeroBgImage}
            orientation="left"
            subTitle="CONTACT"
            title="CONNECT WITH US—CALL,<br /> EMAIL, OR VISIT ANY OF<br />OUR LOCATIONS"
            buttonTitle="CONTACT US"
            buttonLink="mailto:info@hudsonppi.com"
        />
        <ContactInfo />
    </div>
);

export default Contact;
